import { CookieService } from "#core/services/cookie.service";
import { LocalStorageCache } from "#services/local-storage-cache.service";
import { LocalStorage } from "#services/local-storage.service";
import { LoggerService } from "#services/logger.service";
import { SnackBarService } from "#services/snackbar.service";
import { TechCheckService } from "#services/tech-check.service";
import { VersionService } from "#services/version.service";


export const services: any[] = [
    CookieService,
    LocalStorage,
    LocalStorageCache,
    LoggerService,
    SnackBarService,
    TechCheckService,
    VersionService,
];

export * from "#services/cookie.service";
export * from "#services/local-storage-cache.service";
export * from "#services/local-storage.service";
export * from "#services/logger.service";
export * from "#services/snackbar.service";
export * from "#services/tech-check.service";
export * from "#services/version.service";

